import { css, setup, defineConfig, cssom } from '@twind/core';
import presetExt from '@twind/preset-ext';
import presetAutoprefix from '@twind/preset-autoprefix';
import presetTailwind from '@twind/preset-tailwind';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var body = {
	"body-big": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "18px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "26px"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	"body-big-light": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Light'"
		},
		"font-size": {
			value: "18px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "26px"
		},
		"font-weight": {
			value: "300"
		},
		color: {
			value: "black"
		}
	},
	"body-big-semibold": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "18px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "26px"
		},
		"font-weight": {
			value: "600"
		},
		color: {
			value: "black"
		}
	},
	"body-normal": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "24px"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	"body-normal-light": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Light'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "24px"
		},
		"font-weight": {
			value: "300"
		},
		color: {
			value: "black"
		}
	},
	"body-normal-medium": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Medium'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "24px"
		},
		"font-weight": {
			value: "500"
		},
		color: {
			value: "black"
		}
	},
	"body-normal-semibold": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "24px"
		},
		"font-weight": {
			value: "600"
		},
		color: {
			value: "black"
		}
	},
	"body-small": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "14px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	"body-small-semibold": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "14px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "600"
		},
		color: {
			value: "black"
		}
	},
	"body-small-italic": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Italic'"
		},
		"font-size": {
			value: "14px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "400"
		},
		"font-style": {
			value: "italic"
		},
		color: {
			value: "black"
		}
	},
	"body-small-underline": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "14px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "400"
		},
		"text-decoration": {
			value: "underline"
		},
		color: {
			value: "black"
		}
	},
	"body-big-semibold-uppercase": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "18px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "26px"
		},
		"font-weight": {
			value: "600"
		},
		"text-transform": {
			value: "uppercase"
		},
		color: {
			value: "black"
		}
	},
	"body-small-medium": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Medium'"
		},
		"font-size": {
			value: "14px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "500"
		},
		color: {
			value: "black"
		}
	},
	"body-extra-small": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "10px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "16px"
		},
		"font-weight": {
			value: "400"
		},
		display: {
			value: "inline-block"
		}
	},
	"body-extra-small-semibold": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "10px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "16px"
		},
		"font-weight": {
			value: "600"
		},
		display: {
			value: "inline-block"
		}
	},
	"body-extra-small-underline": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "10px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "16px"
		},
		"font-weight": {
			value: "400"
		},
		"text-decoration": {
			value: "underline"
		},
		display: {
			value: "inline-block"
		}
	}
};
var bodyTypography = {
	body: body
};

var fields = {
	"field-helper-text": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "12px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "18px"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	"field-input-text": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "24px"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	"field-label": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "12px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "18px"
		},
		"font-weight": {
			value: "600"
		},
		color: {
			value: "black"
		}
	},
	"field-required-text": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Italic'"
		},
		"font-size": {
			value: "12px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "18px"
		},
		"font-weight": {
			value: "400"
		},
		"font-style": {
			value: "italic"
		},
		color: {
			value: "black"
		}
	},
	"field-placeholder-txt-XS": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "14px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "22px"
		},
		"font-weight": {
			value: "400"
		}
	},
	"field-input-text-xs": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "14px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "22px"
		},
		"font-weight": {
			value: "400"
		}
	}
};
var fieldTypography = {
	fields: fields
};

var tooltip = {
	"tooltip-text": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "10px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "16px"
		},
		"font-weight": {
			value: "600"
		},
		color: {
			value: "black"
		}
	}
};
var Tooltip = {
	"tooltip-text-regular": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "10px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "16px"
		},
		"font-weight": {
			value: "400"
		}
	}
};
var tooltipTypography = {
	tooltip: tooltip,
	Tooltip: Tooltip
};

var button = {
	"button-big": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Bold'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "100%"
		},
		"font-weight": {
			value: "700"
		},
		color: {
			value: "black"
		}
	},
	"button-small": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "14px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "100%"
		},
		"font-weight": {
			value: "600"
		},
		color: {
			value: "black"
		}
	},
	"toggle button": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "10px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "16px"
		},
		"font-weight": {
			value: "600"
		},
		color: {
			value: "black"
		}
	}
};
var buttonTypography = {
	button: button
};

var link = {
	"link-big": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Medium'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "500"
		},
		"text-decoration": {
			value: "underline"
		},
		color: {
			value: "black"
		}
	},
	"link-small": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "13px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "400"
		},
		"text-decoration": {
			value: "underline"
		},
		color: {
			value: "black"
		}
	}
};
var linkTypography = {
	link: link
};

var checkbox = {
	check: {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "14px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	"check-medium": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Medium'"
		},
		"font-size": {
			value: "14px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "500"
		},
		color: {
			value: "black"
		}
	}
};
var checkboxTypography = {
	checkbox: checkbox
};

var table = {
	"header-row-title-bold": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Bold'"
		},
		"font-size": {
			value: "10px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "100%"
		},
		"font-weight": {
			value: "700"
		},
		"text-transform": {
			value: "uppercase"
		},
		color: {
			value: "black"
		}
	},
	"row-text-primary": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "13px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "100%"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	"row-text-secondary": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "11px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "100%"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	"row-text-primary-underlined": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans'"
		},
		"font-size": {
			value: "13px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "100%"
		},
		"font-weight": {
			value: "400"
		},
		"text-decoration": {
			value: "underline"
		},
		color: {
			value: "black"
		}
	}
};
var tableTypography = {
	table: table
};

var tabs = {
	"label-active": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "600"
		},
		"text-transform": {
			value: "uppercase"
		},
		color: {
			value: "black"
		}
	},
	"label-inactive": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "600"
		},
		"text-transform": {
			value: "uppercase"
		},
		color: {
			value: "black"
		}
	}
};
var tabsTypography = {
	tabs: tabs
};

var smallPushTypography = {
	"small-push": {
	"small-push-title": {
		"font-family": {
			value: "'IBM Plex Serif', 'IBMPlexSerif'"
		},
		"font-size": {
			value: "12px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "100%"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	}
}
};

var Code = {
	"font-family": {
		value: "'IBM Plex Mono', 'IBMPlexMono-Regular'"
	},
	"font-size": {
		value: "12px"
	},
	"letter-spacing": {
		value: "0px"
	},
	"line-height": {
		value: "100%"
	},
	"font-weight": {
		value: "400"
	}
};
var codeTypography = {
	Code: Code
};

var headline$1 = {
	"Tiempos-XL": {
		"font-family": {
			value: "'Tiempos Headline', 'TiemposHeadline-Bold'"
		},
		"font-size": {
			value: "68px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "79px"
		},
		"font-weight": {
			value: "700"
		}
	},
	"Tiempos-L": {
		"font-family": {
			value: "'Tiempos Headline', 'TiemposHeadline-Bold'"
		},
		"font-size": {
			value: "58px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "69px"
		},
		"font-weight": {
			value: "700"
		}
	},
	"Tiempos-M": {
		"font-family": {
			value: "'Tiempos Headline', 'TiemposHeadline-Bold'"
		},
		"font-size": {
			value: "48px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "55px"
		},
		"font-weight": {
			value: "700"
		}
	},
	"Tiempos-S": {
		"font-family": {
			value: "'Tiempos Headline', 'TiemposHeadline-Bold'"
		},
		"font-size": {
			value: "38px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "45px"
		},
		"font-weight": {
			value: "700"
		}
	}
};
var tiemposTypography = {
	headline: headline$1
};

var singlePurposeWidgetTypography = {
	"single-purpose": {
	"title-L": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Bold'"
		},
		"font-size": {
			value: "28px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "40px"
		},
		"font-weight": {
			value: "700"
		}
	},
	"title-M": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Bold'"
		},
		"font-size": {
			value: "22px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "30px"
		},
		"font-weight": {
			value: "700"
		}
	},
	"title-S": {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Bold'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "24px"
		},
		"font-weight": {
			value: "700"
		}
	}
}
};

var headline = {
	h1: {
		"font-family": {
			value: "'IBM Plex Serif', 'IBMPlexSerif'"
		},
		"font-size": {
			value: "32px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "37px"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	h2: {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-Bold'"
		},
		"font-size": {
			value: "24px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "31px"
		},
		"font-weight": {
			value: "700"
		},
		color: {
			value: "black"
		}
	},
	h3: {
		"font-family": {
			value: "'IBM Plex Serif', 'IBMPlexSerif'"
		},
		"font-size": {
			value: "20px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "30px"
		},
		"font-weight": {
			value: "400"
		},
		color: {
			value: "black"
		}
	},
	h4: {
		"font-family": {
			value: "'IBM Plex Sans', 'IBMPlexSans-SemiBold'"
		},
		"font-size": {
			value: "16px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "20px"
		},
		"font-weight": {
			value: "600"
		},
		color: {
			value: "black"
		}
	},
	"h3-bold": {
		"font-family": {
			value: "'IBM Plex Serif', 'IBMPlexSerif-Bold'"
		},
		"font-size": {
			value: "20px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "30px"
		},
		"font-weight": {
			value: "700"
		},
		color: {
			value: "black"
		}
	},
	"h1-catchline": {
		"font-family": {
			value: "'IBM Plex Serif', 'IBMPlexSerif-Bold'"
		},
		"font-size": {
			value: "48px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "62px"
		},
		"font-weight": {
			value: "700"
		},
		color: {
			value: "black"
		}
	},
	"h1-semi-bold": {
		"font-family": {
			value: "'IBM Plex Serif', 'IBMPlexSerif-SemiBold'"
		},
		"font-size": {
			value: "32px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "40px"
		},
		"font-weight": {
			value: "600"
		},
		color: {
			value: "black"
		}
	},
	"h1-catchline-medium": {
		"font-family": {
			value: "'IBM Plex Serif', 'IBMPlexSerif-Bold'"
		},
		"font-size": {
			value: "42px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "56px"
		},
		"font-weight": {
			value: "700"
		},
		color: {
			value: "black"
		}
	},
	carousel: {
		"carousel-headline-semi-bold": {
			"font-family": {
				value: "'IBM Plex Serif', 'IBMPlexSerif-SemiBold'"
			},
			"font-size": {
				value: "24px"
			},
			"letter-spacing": {
				value: "0px"
			},
			"line-height": {
				value: "32px"
			},
			"font-weight": {
				value: "600"
			},
			color: {
				value: "black"
			}
		}
	},
	"h5-bold": {
		"font-family": {
			value: "'IBM Plex Serif', 'IBMPlexSerif-Bold'"
		},
		"font-size": {
			value: "12px"
		},
		"letter-spacing": {
			value: "0px"
		},
		"line-height": {
			value: "16px"
		},
		"font-weight": {
			value: "700"
		},
		color: {
			value: "black"
		}
	},
	email: {
		"email-headline-bold": {
			"font-family": {
				value: "'Tiempos Headline', 'TiemposHeadline-Bold'"
			},
			"font-size": {
				value: "44px"
			},
			"letter-spacing": {
				value: "0px"
			},
			"line-height": {
				value: "56px"
			},
			"font-weight": {
				value: "700"
			}
		}
	}
};
var headlineTypography = {
	headline: headline
};

var Typographies = {
  'headline': headlineTypography,
  'body': bodyTypography,
  'fields': fieldTypography,
  'tooltip': tooltipTypography,
  'button': buttonTypography,
  'link': linkTypography,
  'checkbox': checkboxTypography,
  'table': tableTypography,
  'tabs': tabsTypography,
  'small-push': smallPushTypography,
  'code': codeTypography,
  'tiempos': tiemposTypography,
  'single-purpose-widget': singlePurposeWidgetTypography
};
var VALID_ATTRIBUTES = ['font-family', 'font-size', 'letter-spacing', 'line-height', 'font-weight'];
/**
 * Get classes object from a typography object. No matter the deepness of the class definition it detects objects with
 * $VALID_ATTRIBUTES as attributes
 */

var getClassesFromTypographyObject = function getClassesFromTypographyObject(typographies) {
  var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  for (var _i = 0, _Object$keys = Object.keys(typographies); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var typographyClass = typographies[key];
    var isClassObject = Object.keys(typographyClass).some(function (attributeKey) {
      return VALID_ATTRIBUTES.includes(attributeKey);
    });

    if (isClassObject) {
      var keyNormalized = key.toLowerCase().replace(/ /g, '-');
      classes[keyNormalized] = typographyClass;
    } else if (typographyClass instanceof Object) {
      getClassesFromTypographyObject(typographyClass, classes);
    }
  }

  return classes;
};
/**
 * Get a list of all generated class names
 */


var getTypographyGeneratedClassNames = function getTypographyGeneratedClassNames() {
  return Object.keys(getClassesFromTypographyObject(Typographies));
};
/**
 * Get class definitions ready to use in Twind dynamically generated from Zero Height definitions
 */

var zeroHeightTypographiesToClasses = function zeroHeightTypographiesToClasses() {
  var classes = getClassesFromTypographyObject(Typographies);
  return Object.keys(classes).map(function (className) {
    var classDefinition = classes[className];
    return [className, css(Object.keys(classDefinition).reduce(function (attributes, attributeNameKey) {
      if (VALID_ATTRIBUTES.includes(attributeNameKey)) {
        return _objectSpread2(_objectSpread2({}, attributes), {}, _defineProperty({}, attributeNameKey, classDefinition[attributeNameKey].value));
      }

      return attributes;
    }), {})];
  });
};

var Primary = {
	"blue-1": {
		value: "#d1effa"
	},
	"blue-2": {
		value: "#84d1eb"
	},
	"blue-3": {
		value: "#2fabd5"
	},
	"blue-4": {
		value: "#3186af"
	},
	"blue-5": {
		value: "#265973"
	},
	"blue-6": {
		value: "#1d4153"
	},
	"pink-1": {
		value: "#fff6f2"
	},
	"pink-2": {
		value: "#fff0eb"
	},
	"pink-3": {
		value: "#ffd5c8"
	},
	"pink-4": {
		value: "#e58c71"
	},
	"pink-5": {
		value: "#d66a49"
	},
	"pink-0": {
		value: "#fffbf9"
	}
};

var Secondary = {
	"cobalt-blue-1": {
		value: "#f0f5ff"
	},
	"cobalt-blue-3": {
		value: "#2e62d6"
	},
	"green-1": {
		value: "#eefff6"
	},
	"green-3": {
		value: "#10c767"
	},
	"purple-1": {
		value: "#f8ecff"
	},
	"purple-3": {
		value: "#a734ee"
	},
	"red-1": {
		value: "#ffe9e8"
	},
	"red-3": {
		value: "#ea4335"
	},
	"red-4": {
		value: "#b10e00"
	},
	"teal-1": {
		value: "#e6faf7"
	},
	"teal-3": {
		value: "#21c6b2"
	},
	"yellow-1": {
		value: "#fff9eb"
	},
	"yellow-3": {
		value: "#ebae12"
	},
	"cobalt-blue-4": {
		value: "#2450b2"
	}
};

var Neutral = {
	"grey-1": {
		value: "#f9fafa"
	},
	"grey-2": {
		value: "#eff7fb"
	},
	"grey-3": {
		value: "#e2f1f8"
	},
	"grey-4": {
		value: "#c9dfe8"
	},
	"grey-5": {
		value: "#9ebdcb"
	},
	"grey-6": {
		value: "#668a99"
	},
	"grey-7": {
		value: "#526e7a"
	},
	"grey-8": {
		value: "#33454c"
	},
	"grey-9": {
		value: "#22262a"
	},
	white: {
		value: "#ffffff"
	},
	"grey-0": {
		value: "#959595"
	}
};

var gradient = {
	"blue-rightpanel": {
		value: "linear-gradient(314.18deg, rgba(29, 65, 83, 1.0) 0%, rgba(39, 111, 148, 1.0) 100%)"
	},
	"pink-login": {
		value: "linear-gradient(285.19deg, rgba(244, 208, 196, 1.0) 0%, rgba(254, 243, 238, 1.0) 100%)"
	},
	"light-blue": {
		value: "linear-gradient(314.69deg, rgba(239, 247, 251, 1.0) 0%, rgba(249, 250, 250, 1.0) 100%)"
	},
	"compliance-acceptable-orange": {
		value: "linear-gradient(225.0deg, rgba(214, 106, 73, 1.0) 0%, rgba(234, 168, 91, 1.0) 100%)"
	},
	"compliance-good-green": {
		value: "linear-gradient(225.0deg, rgba(234, 168, 91, 1.0) 0%, rgba(180, 210, 95, 1.0) 100%)"
	},
	"compliance-low-red": {
		value: "linear-gradient(0.0deg, rgba(214, 106, 73, 1.0) 0%, rgba(192, 60, 20, 1.0) 100%)"
	},
	"compliance-perfect-green": {
		value: "linear-gradient(225.0deg, rgba(180, 210, 95, 1.0) 0%, rgba(16, 199, 103, 1.0) 100%)"
	},
	"light-pink": {
		value: "linear-gradient(314.7deg, rgba(255, 249, 246, 1.0) 0%, rgba(255, 254, 253, 1.0) 50%)"
	},
	"rainbow-background": {
		value: "linear-gradient(151.09deg, rgba(250, 251, 255, 1.0) 0%, rgba(250, 251, 255, 1.0) 44%, rgba(253, 232, 238, 0.7) 81%, rgba(212, 229, 249, 1.0) 100%)"
	}
};

var shadow$4 = {
	login: {
		card: {
			value: "0.0px 34.0px 60.0px 0px rgba(0, 0, 0, 0.15)"
		}
	},
	card: {
		value: "0.0px 5.0px 10.0px 0px rgba(0, 0, 0, 0.08)"
	}
};

var shadow$3 = {
	chat: {
		"chat-icon-shadow": {
			value: "0.0px 24.0px 24.0px 0px rgba(0, 0, 0, 0.35)"
		}
	}
};

var shadow$2 = {
	dropdown: {
		"dropdown-big": {
			value: "0.0px 24.0px 24.0px 1.0px rgba(0, 0, 0, 0.12)"
		}
	}
};

var shadow$1 = {
	button: {
		"shadow-hover": {
			value: "0.0px 8.0px 15.0px 1.0px rgba(150, 150, 150, 0.25)"
		},
		"shadow-label": {
			value: "0.0px 0.0px 2.0px 0px rgba(29, 29, 29, 0.55)"
		},
		"shadow-pressed": {
			value: "0.0px 4.0px 5.0px 1.0px rgba(150, 150, 150, 0.6)"
		}
	}
};

var shadow = {
	topbar: {
		"topbar-icon-shadow": {
			value: "0.0px 13.0px 24.0px 0px rgba(0, 0, 0, 0.35)"
		}
	},
	sidebar: {
		"active-section": {
			value: "0.0px 2.767256498336792px 2.2138051986694336px 0px rgba(0, 0, 0, 0.02),0.0px 6.650102138519287px 5.32008171081543px 0px rgba(0, 0, 0, 0.03),0.0px 12.521552085876465px 10.017241477966309px 0px rgba(0, 0, 0, 0.04)"
		},
		open: {
			value: "6.0px 0.0px 24.0px 0px rgba(0, 0, 0, 0.03)"
		}
	}
};

var push = {
	"small-push": {
		value: "0.0px 2.767256498336792px 2.2138051986694336px 0px rgba(0, 0, 0, 0.02),0.0px 6.650102138519287px 5.32008171081543px 0px rgba(0, 0, 0, 0.03),0.0px 12.521552085876465px 10.017241477966309px 0px rgba(0, 0, 0, 0.04),0.0px 22.3363094329834px 17.869047164916992px 0px rgba(0, 0, 0, 0.05)"
	}
};

var spaces = {
	"space-xxxs": {
	value: "4px"
},
	"space-xxs": {
	value: "8px"
},
	"space-xs": {
	value: "16px"
},
	"space-s": {
	value: "24px"
},
	"space-m": {
	value: "32px"
},
	"space-l": {
	value: "48px"
},
	"space-xl": {
	value: "56px"
},
	"space-xxl": {
	value: "64px"
},
	"space-xxxl": {
	value: "96px"
}
};

var theme = {
  screens: {
    'sm': '576px',
    'md': '768px',
    'lg': '992px',
    'xl': '1200px',
    '2xl': '1536px'
  },
  extend: {
    colors: {
      transparent: 'transparent',
      white: Neutral.white.value,
      neutral: {
        gray: {
          0: Neutral['grey-0'].value,
          1: Neutral['grey-1'].value,
          2: Neutral['grey-2'].value,
          3: Neutral['grey-3'].value,
          4: Neutral['grey-4'].value,
          5: Neutral['grey-5'].value,
          6: Neutral['grey-6'].value,
          7: Neutral['grey-7'].value,
          8: Neutral['grey-8'].value,
          9: Neutral['grey-9'].value
        },
        white: Neutral.white.value
      },
      primary: {
        blue: {
          1: Primary['blue-1'].value,
          2: Primary['blue-2'].value,
          3: Primary['blue-3'].value,
          4: Primary['blue-4'].value,
          5: Primary['blue-5'].value,
          6: Primary['blue-6'].value
        },
        pink: {
          0: Primary['pink-0'].value,
          1: Primary['pink-1'].value,
          2: Primary['pink-2'].value,
          3: Primary['pink-3'].value,
          4: Primary['pink-4'].value,
          5: Primary['pink-5'].value
        }
      },
      secondary: {
        'cobalt-blue': {
          1: Secondary['cobalt-blue-1'].value,
          3: Secondary['cobalt-blue-3'].value,
          4: Secondary['cobalt-blue-4'].value
        },
        'green': {
          1: Secondary['green-1'].value,
          3: Secondary['green-3'].value
        },
        'purple': {
          1: Secondary['purple-1'].value,
          3: Secondary['purple-3'].value
        },
        'red': {
          1: Secondary['red-1'].value,
          3: Secondary['red-3'].value,
          4: Secondary['red-4'].value
        },
        'yellow': {
          1: Secondary['yellow-1'].value,
          3: Secondary['yellow-3'].value
        }
      }
    },
    boxShadow: {
      'chat-icon': shadow$3.chat['chat-icon-shadow'].value,
      'button-hover': shadow$1.button['shadow-hover'].value,
      'button-label': shadow$1.button['shadow-label'].value,
      'button-pressed': shadow$1.button['shadow-pressed'].value,
      'dropdown-big': shadow$2.dropdown['dropdown-big'].value,
      'login-card': shadow$4.login.card.value,
      'card': shadow$4.card.value,
      'topbar-icon': shadow.topbar['topbar-icon-shadow'].value,
      'sidenav-active-section': shadow.sidebar['active-section'].value,
      'sidenav-open': shadow.sidebar['open'].value,
      'input-focused': "0 0 0 3px ".concat(Primary['blue-2'].value),
      'small-push': push['small-push'].value
    },
    spacing: {
      xxxs: spaces['space-xxxs'].value,
      xxs: spaces['space-xxs'].value,
      xs: spaces['space-xs'].value,
      s: spaces['space-s'].value,
      m: spaces['space-m'].value,
      l: spaces['space-l'].value,
      xl: spaces['space-xl'].value,
      xxl: spaces['space-xxl'].value,
      xxxl: spaces['space-xxxl'].value
    },
    gap: {
      xxxs: spaces['space-xxxs'].value,
      xxs: spaces['space-xxs'].value,
      xs: spaces['space-xs'].value,
      s: spaces['space-s'].value,
      m: spaces['space-m'].value,
      l: spaces['space-l'].value,
      xl: spaces['space-xl'].value,
      xxl: spaces['space-xxl'].value,
      xxxl: spaces['space-xxxl'].value
    },
    fontFamily: {
      'sans': [body['body-normal']['font-family'].value],
      'serif': [headline['h1']['font-family'].value],
      'sans-italic': [fields['field-required-text']['font-family'].value]
    },
    fontSize: {
      'body-normal': body['body-normal']['font-size'].value,
      'body-small': body['body-small']['font-size'].value,
      'body-extra-small': body['body-extra-small']['font-size'].value,
      'body-big': body['body-big']['font-size'].value,
      'button-big': button['button-big']['font-size'].value,
      'button-small': button['button-small']['font-size'].value,
      'tooltip': tooltip['tooltip-text']['font-size'].value,
      'h1': headline.h1['font-size'].value,
      'h1-catchline': headline['h1-catchline']['font-size'].value,
      'h1-catchline-medium': headline['h1-catchline-medium']['font-size'].value,
      'h2': headline.h2['font-size'].value,
      'h3': headline.h3['font-size'].value,
      'h4': headline.h4['font-size'].value,
      'link-big': link['link-big']['font-size'].value,
      'link-small': link['link-small']['font-size'].value,
      'row-secondary': table['row-text-secondary']['font-size'].value,
      'header-row-title-bold': table['header-row-title-bold']['font-size'].value,
      'row-text-primary': table['row-text-primary']['font-size'].value,
      'row-text-primary-underlined': table['row-text-primary-underlined']['font-size'].value,
      'field-label': fields['field-label']['font-size'].value,
      'field-input-text': fields['field-input-text']['font-size'].value,
      'field-helper-text': fields['field-helper-text']['font-size'].value,
      'field-required-text': fields['field-required-text']['font-size'].value
    },
    letterSpacing: {
      'h1': headline.h1['letter-spacing'].value,
      'h1-catchline': headline['h1-catchline']['letter-spacing'].value,
      'h1-catchline-medium': headline['h1-catchline-medium']['letter-spacing'].value,
      'h2': headline.h2['letter-spacing'].value,
      'h3': headline.h3['letter-spacing'].value,
      'h4': headline.h4['letter-spacing'].value,
      'body': body['body-normal']['letter-spacing'].value,
      'body-small': body['body-small']['letter-spacing'].value,
      'body-big': body['body-big']['letter-spacing'].value,
      'tooltip': tooltip['tooltip-text']['letter-spacing'].value,
      'header-row-title-bold': table['header-row-title-bold']['letter-spacing'].value,
      'row-text-primary': table['row-text-primary']['letter-spacing'].value,
      'row-text-primary-underlined': table['row-text-primary-underlined']['letter-spacing'].value,
      'field-label': fields['field-label']['letter-spacing'].value,
      'field-input-text': fields['field-input-text']['letter-spacing'].value,
      'field-helper-text': fields['field-helper-text']['letter-spacing'].value,
      'field-required-text': fields['field-required-text']['letter-spacing'].value
    },
    lineHeight: {
      'h1': headline.h1['line-height'].value,
      'h1-catchline': headline['h1-catchline']['line-height'].value,
      'h1-catchline-medium': headline['h1-catchline-medium']['line-height'].value,
      'h2': headline.h2['line-height'].value,
      'h3': headline.h3['line-height'].value,
      'h4': headline.h4['line-height'].value,
      'body': body['body-normal']['line-height'].value,
      'body-big': body['body-big']['line-height'].value,
      'body-small': body['body-small']['line-height'].value,
      'tooltip': tooltip['tooltip-text']['line-height'].value,
      'header-row-title-bold': table['header-row-title-bold']['line-height'].value,
      'row-text-primary': table['row-text-primary']['line-height'].value,
      'row-text-primary-underlined': table['row-text-primary-underlined']['line-height'].value,
      'field-label': fields['field-label']['line-height'].value,
      'field-input-text': fields['field-input-text']['line-height'].value,
      'field-helper-text': fields['field-helper-text']['line-height'].value,
      'field-required-text': fields['field-required-text']['line-height'].value
    },
    backgroundImage: {
      'pink-gradient': 'radial-gradient(86.8% 86.8% at 0% 0%, #fef3ee 22.92%, #f4d0c4 100%)',
      'blue-rightpanel': 'linear-gradient(-45.82deg, rgba(29, 65, 83, 1.0) 0%, rgba(39, 111, 148, 1.0) 100%)',
      'light-blue': 'linear-gradient(-45.31deg, rgba(239, 247, 251, 1.0) 0%, rgba(249, 250, 250, 1.0) 100%)',
      'pink-login': 'linear-gradient(-74.81deg, rgba(244, 208, 196, 1.0) 0%, rgba(254, 243, 238, 1.0) 100%)',
      'rainbow': gradient['rainbow-background'].value
    }
  }
};
function presetDidomi() {
  return {
    ignorelist: [/^(didomi-|label)/, 'ReactQueryDevtoolsPanel', 'hydrated', /.*-root$/g],
    rules: _toConsumableArray(zeroHeightTypographiesToClasses()),
    theme: theme
  };
}

var connect = function connect(target) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var additionalPresets = config.presets || [];
  var prefix = target.replace('.', '').replace('-root', '');
  setup(defineConfig(_objectSpread2(_objectSpread2({}, config), {}, {
    hash: function hash(className) {
      return "".concat(prefix, "-").concat(className);
    },
    preflight: function preflight(_preflight) {
      return config !== null && config !== void 0 && config.normalize ? _preflight : null;
    },
    presets: [presetAutoprefix(), presetTailwind(), presetExt(), presetDidomi()].concat(_toConsumableArray(additionalPresets))
  })), cssom(target), document.querySelector(target) || document.body);
};

export { connect, getTypographyGeneratedClassNames };
